/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Invoice_NumberInputs */

const en_inbound_field_invoice_number = /** @type {(inputs: Inbound_Field_Invoice_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice number`)
};

/**
* | output |
* | --- |
* | "Invoice number" |
*
* @param {Inbound_Field_Invoice_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_invoice_number = /** @type {((inputs?: Inbound_Field_Invoice_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Invoice_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_invoice_number(inputs)
});